DialogController = App.loadClass 'core::Angular/DialogController'

class exports.PlanDetailsDialogController extends DialogController

    constructor: (@scope, @transitions, @modalInstance, @repo, survey_result, field) ->
        super(@scope, @transitions, @modalInstance)

        @scope.title = 'Plan Details'

        @scope.placeholder = 'Loading products...'
        @scope.products = []

        @loadPlanDetails(survey_result, field)

    loadPlanDetails: (survey_result, field) =>
        @repo.getPlanDetails(survey_result, field).then (result) =>
            if result.data?.status?.type isnt 'success'
                if result.data?.status?
                    @scope.setAlert(result.data?.status)
                else
                    @scope.setAlert
                        type: 'error'
                        msg: 'Failed to load products for this plan'
                return

            if result.data.data.plan_type?
                @scope.title = "#{result.data.data.plan_type} Details"

            @scope.products = result.data.data.products
            if @scope.products.length is 0
                @scope.placeholder = 'No products found'

        , () =>
            # if the request failed
            @scope.setAlert
                type: 'error'
                msg: 'Failed to load products for this plan'
